import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { LoginComponent } from './login/login.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { ChangePasswordService } from './changepassword/services/changePassword.service';
import { RegisterIkService } from './register/services/registerIk.service';
import { RegisterIkMockService } from './register/services/registerIk.serviceMock';
import { EqualValidator } from './changepassword/password.match.directive';
import { ChangePasswordMockService } from './changepassword/services/changePassword.serviceMock';
import { environment } from '../../environments/environment';
import { RegisterComponent } from './register/register.component';
import { ResetAccountComponent } from './resetAccount/resetAccount.component';

@NgModule({
  imports: [
    CommonModule,
    AccountRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  declarations: [
    LoginComponent,
    ChangepasswordComponent,
    EqualValidator,
    RegisterComponent,
    ResetAccountComponent
],
  providers: [ {
      provide: 'IChangePasswordService',
      useClass:    (environment.mockServices ? ChangePasswordMockService : ChangePasswordService )
    },
    {
      provide: 'IRegisterIkService',
      useClass:    (environment.mockServices ? RegisterIkMockService : RegisterIkService )
    }
  ]
})
export class AccountModule { }



// WEBPACK FOOTER //
// ./src/app/account/account.module.ts